import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue'
import { useHubs } from '@/common/useHubs'
import { useCurrentOrg } from '@/common/useCurrentOrg'
import { useGetLocationTypesQuery } from '@/api/location-types'
import { sortBy } from 'lodash'
import VsWrapper from '@/components/vision/VsWrapper.vue'
import AutoComplete from '@/components/common/AutoComplete.vue'
import VsTextInput from '@/components/vision/Inputs/VsTextInput.vue'
import { useStore } from 'vuex-composition-helpers'
import VsHeading from '@/components/vision/VsHeading.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'OnTheFlyLocationRequiredFields',
  props: {
    locationName: null,
    locationTypeId: null,
    locationOwnerId: null,
    locationPrivate: { type: [Boolean, null] }
  },
  emits: [
  'location-owner-input',
  'location-type-input',
  'location-name-input',
  'location-private-input',
],
  setup(__props: any, { emit }) {

const props = __props as {
  locationName?: string | null
  locationTypeId?: number | null
  locationOwnerId?: string | null
  locationPrivate?: boolean | null
}





const { currentHubOwner } = useHubs()
const { currentOrg } = useCurrentOrg()
const store = useStore()

const isHubUser = computed<boolean>(
  () => store.getters['permissions/isHostOrganizationUser']
)
const isLocationOwnedByCurrentOrganizationToggle = ref(
  props.locationOwnerId !== currentOrg.value?.id
)
const privateToggle = ref(!!props.locationPrivate)
watch(
  () => props.locationOwnerId,
  (newVal) => {
    isLocationOwnedByCurrentOrganizationToggle.value =
      newVal !== currentOrg.value?.id
  },
  { immediate: true }
)
watch(
  () => props.locationPrivate,
  (newVal) => {
    privateToggle.value = !!newVal
  },
  { immediate: true }
)
const ownerOptions = computed(() => {
  if (!currentOrg.value) return []
  return [
    {
      value: currentOrg.value.id,
      text: currentOrg.value.name,
    },
  ]
})
const { data: locTypeQueryData } = useGetLocationTypesQuery({
  includeUnused: true,
})
const locationTypes = computed(() => {
  return sortBy(
    locTypeQueryData.value?.map((locationType) => ({
      text: locationType.name,
      value: locationType.id,
      icon: locationType.iconId || 'mdi-map-marker',
    })),
    'text'
  )
})

function onOwnerRadioChanged(e: boolean) {
  if (!e) {
    emit('location-owner-input', currentOrg.value?.id ?? '')
  } else {
    emit('location-owner-input', currentHubOwner.value?.id ?? '')
    emit('location-private-input', false)
  }
}

function onPrivateChanged(e: boolean) {
  emit('location-private-input', e)
}

return { __sfc: true,props, emit, currentHubOwner, currentOrg, store, isHubUser, isLocationOwnedByCurrentOrganizationToggle, privateToggle, ownerOptions, locTypeQueryData, locationTypes, onOwnerRadioChanged, onPrivateChanged, VsWrapper, AutoComplete, VsTextInput, VsHeading }
}

})